<template>
  <div class="contents item-box">
    <div class="video">
      <template v-if="getType(info.videoUrl)">
        <!-- <video controls poster="/static/poster.jpg">
          <source :src="info.videoUrl" type="video/mp4" />
          您的浏览器不支持 video 标签。
        </video> -->
        <video-player
          class="video-player-box"
          ref="videoPlayer"
          :options="getplayerOptions(info.videoUrl)"
        >
        </video-player>
      </template>
      <iframe
        v-else-if="info.videoUrl && info.videoUrl != ''"
        :src="info.videoUrl"
        scrolling="no"
        border="0"
        frameborder="no"
        framespacing="0"
        allowfullscreen="true"
      >
      </iframe>
      <img v-else :src="info.picUrl" />
    </div>

    <div class="info">
      <div class="info-title">
        <img class="info-title-img" src="/static/industry/icon.png" />{{
          info.title
        }}
      </div>
      <div class="info-info">
        <p>
          {{ info.lable }}
        </p>
      </div>

      <div v-if="!typeOne" class="info-list">
        <div
          class="info-list-item"
          v-for="(item, index) in info.list.slice(0, 4)"
          :key="'info3-' + index"
          :class="{ 'info-list-item-active': (index + 1) % 4 == 0 }"
        >
          <img :src="item.icon" />
          <p>{{ item.title }}</p>
        </div>
        <div v-if="!typeOne && info.list.length > 4" class="info-list">
          <div
            class="info-list-item"
            v-for="(item, index) in info.list.slice(4, info.list.length)"
            :key="'info4-' + index"
            :class="{ 'info-list-item-active': (index + 1) % 4 == 0 }"
          >
            <img :src="item.icon" />
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div>
      <div v-if="typeOne" class="info-list">
        <div
          class="info-list-item info-list-item-one"
          v-for="(item, index) in info.list.slice(0, 5)"
          :key="'info23-' + index"
          :class="{ 'info-list-item-active': (index + 1) % 5 == 0 }"
        >
          <img :src="item.icon" />
          <p>{{ item.title }}</p>
        </div>
      </div>
      <div v-if="typeOne && info.list.length > 5" class="info-list">
        <div
          class="info-list-item info-list-item-one"
          v-for="(item, index) in info.list.slice(5, info.list.length)"
          :key="'info2-' + index"
          :class="{ 'info-list-item-active': (index + 1) % 5 == 0 }"
        >
          <img :src="item.icon" />
          <p>{{ item.title }}</p>
        </div>
      </div>

      <div class="info-list-process" v-if="info.process">
        <div
          class="info-list-item-process info-list-item-process-right"
          v-for="(item, index) in info.process.slice(0, 5)"
          :key="'info4-' + index"
          :class="{
            'info-list-item-process-active':
              (index + 1) % 5 == 0 || index + 1 == info.process.length
          }"
        >
          <div class="process-item">
            <img :src="item.icon" />
            <span class="process-step">{{ step(index) }}</span>
          </div>
          <p class="process-title">{{ item.title }}</p>
        </div>
      </div>

      <div
        class="info-list-process"
        v-if="info.process && info.process.length > 5"
      >
        <div
          class="info-list-item-process info-list-item-process-right"
          v-for="(item, index) in info.process.slice(5, 10)"
          :key="'info-' + index"
          :class="{
            'info-list-item-process-active':
              (index + 1) % 5 == 0 || index + 6 == info.process.length
          }"
        >
          <div class="process-item">
            <img :src="item.icon" />
            <span class="process-step">{{ step(index) }}</span>
          </div>
          <p class="process-title">{{ item.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playerOptions: {
        // videojs options
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src:
              "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }
        ],
        poster: "/static/poster.jpg"
      }
    };
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 计算属性的 getter
    typeOne: function() {
      return this.info.list.length == 5 || this.info.list.length > 8;
    }
  },
  methods: {
    step(val) {
      let stepVal = val + 1;
      if (stepVal < 10) {
        stepVal = "0" + stepVal;
      }
      return stepVal;
    },
    getType(val) {
      return this.$FUnitls.matchType(val) == "video";
    },
    getplayerOptions(url) {
      let playerOptions = {
        // videojs options
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: url
          }
        ],
        poster: "/static/poster.jpg"
      };
      return playerOptions;
    }
  }
};
</script>

<style scoped>
.video {
  position: relative;
  width: 550px;
  height: 360px;
}

.video iframe,
.video iframe {
  position: absolute;
  width: 550px;
  height: 360px;
  left: 0;
  top: 0;
}
.video video {
  position: absolute;
  width: 550px;
  height: 320px;
  left: 0;
  top: 0;
}
.video-player-box {
  position: absolute;
  width: 550px;
  height: 320px;
  left: 0;
  top: 0;
}
.video-player-box >>> .video-js {
  width: 550px;
  height: 320px;
  background-color: #ffffff;
}
.video-player-box >>> .vjs-big-play-button {
  display: none;
}


.info-list img,
.info-list-process img {
  width: 50px;
  height: 50px;
}
.item-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.info {
  width: 544px;
}
.info .info-title {
  font-weight: 700;
  font-size: 20px;
  letter-spacing: 3px;
  color: #2655ad;
}
.info-title-img {
  margin-right: 17px;
}

.info-info {
  margin-top: 20px;
}
.info-info p {
  font-size: 14px;
  letter-spacing: 1.5px;
  color: #333333;
  line-height: 200%;
}
.info-list {
  width: 544px;
  overflow: hidden;
}
.info-list .info-list-item {
  width: 103px;
  margin-right: 43px;
  float: left;
  text-align: center;
  margin-top: 30px;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}

.info-list .info-list-item p {
  margin-top: 13px;
}
.info-list .info-list-item-one {
  width: 100px;
  margin-right: 10px;
}
.info-list .info-list-item-active {
  margin-right: 0;
}

.info-list-process {
  width: 544px;
  overflow: hidden;
  margin-top: 20px;
}
.info-list-process .info-list-item-process {
  width: 20%;
  float: left;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  position: relative;
}
.info-list-process .info-list-item-process::before {
  position: absolute;
  content: " ";
  top: 17px;
  right: -12px;
  width: 23px;
  height: 16px;
  background: url(/static/icon/industry/right.png) no-repeat;
  background-size: 100% 100%;
}
.info-list-item-process .info-list-item-process-active {
  margin-right: 0;
}
.info-list-item-process-active::before {
  display: none;
}
.process-item {
  width: 54px;
  height: 54px;
  position: relative;
}
.process-item .process-step {
  position: absolute;
  left: 0;
  right: 0;
  top: 26px;
  color: #e1e2e3;
  font-size: 14px;
  font-weight: 700;
}
.info-list-item-process-right .process-title {
  margin-top: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/industry/IndustryList.vue